/** @jsx jsx */
import { memo } from "react";
import { jsx } from "theme-ui";
import { AspectRatio } from "theme-ui";
import useTheme from "../../useTheme";
import CDNImage from "..";

var CDNPoster = function CDNPoster(_a) {
  var _b, _c;

  var src = _a.src,
      sizes = _a.sizes,
      aspectRatio = _a.aspectRatio,
      className = _a.className,
      alt = _a.alt;
  var theme = useTheme().theme;
  return jsx(AspectRatio, {
    ratio: aspectRatio,
    className: className,
    sx: {
      backgroundColor: "rgba(0,0,0, .5)",
      overflow: "hidden",
      borderRadius: (_c = (_b = theme.images) === null || _b === void 0 ? void 0 : _b.poster) === null || _c === void 0 ? void 0 : _c["borderRadius"]
    }
  }, src ? jsx(CDNImage, {
    alt: alt,
    src: src,
    width: sizes,
    sx: {
      height: "100%",
      objectFit: "cover",
      position: "absolute",
      right: 0,
      top: 0,
      width: "100%"
    }
  }) : jsx("div", {
    sx: {
      color: "#fff",
      alignItems: "center",
      display: "flex",
      fontWeight: "bold",
      height: "100%",
      justifyContent: "center",
      padding: 2,
      textAlign: "center",
      userSelect: "none"
    }
  }, alt));
};

export default memo(CDNPoster);